import { create } from "zustand";

export type ClientDetails = {
  pan?: string;
  name?: string;
  email?: string;
};

interface LayoutStore {
  isLeftNavOpen: boolean;
  isClientDrawerOpen: boolean;
  isReinvestModalOpen: boolean;
  reinvestDeal: any;
  clientId: string | null;
  clientDetails?: ClientDetails;
  partnerId?: string | null;
  isPartnerDrawerOpen: boolean;
  partnerDetails?: any;
  familyAccountID?: string | null;
  familyAccountDetails?: any;
  isFamilyAccountDrawerOpen: boolean;
  refetchClientData?: () => void;
  refetchClientSummary?: () => void;
  refetchPartnerData?: () => void;
  refetchPartnerSummary?: () => void;
  setIsLeftOpen: () => void;
  setClientId: (clientId: string | null) => void;
  setReinvestDeal: (reinvestDeal: any) => void;
  setClientDetails: (clientDetails) => void;
  setIsClientDrawerOpen: (clientId?: string | null) => void;
  setPartnerDetails: (partnerDetails) => void;
  setIsPartnerDrawerOpen: (partnerId?: string | null) => void;
  setIsReinvestModalOpen: (isReinvestModalOpen: boolean) => void;
  setPartnerId: (partnerId: string | null) => void;
  setFamilyAccountID: (familyAccountID: string | null) => void;
  setFamilyAccountDetails: (familyAccountDetails) => void;
  setIsFamilyAccountDrawerOpen: (familyAccountID?: string | null) => void;
  setRefetchClientData: (refetchFn?: () => void) => void;
  setRefetchClientSummary: (refetchFn?: () => void) => void;
  setRefetchPartnerData: (refetchFn?: () => void) => void;
  setRefetchPartnerSummary: (refetchFn?: () => void) => void;
}
export const useLayoutStore = create<LayoutStore>((set) => ({
  isLeftNavOpen: false,
  isClientDrawerOpen: false,
  isReinvestModalOpen: false,
  clientId: null,
  reinvestDeal: null,
  isPartnerDrawerOpen: false,
  partnerId: null, // this is the subPartnerPublicId
  familyAccountID: null,
  familyAccountDetails: null,
  isFamilyAccountDrawerOpen: false,
  partnerDetails: null,
  refetchClientData: undefined,
  refetchClientSummary: undefined,
  refetchPartnerData: undefined,
  refetchPartnerSummary: undefined,
  setIsLeftOpen: () => {
    return set((state) => ({ isLeftNavOpen: !state.isLeftNavOpen }));
  },
  setIsClientDrawerOpen: (clientId?: string | null) => {
    // Clear client details when drawer is closed

    return set((state) => ({
      isClientDrawerOpen:
        (clientId !== null && clientId !== undefined) || !state.isClientDrawerOpen,
      clientId: clientId || null,
      clientDetails: clientId ? state.clientDetails : undefined,
    }));
  },
  setClientId: (clientId: string | null) => {
    return set((state) => ({ ...state, clientId }));
  },
  setClientDetails: (clientDetails: ClientDetails) => {
    return set((state) => ({
      ...state,
      clientDetails: { ...state.clientDetails, ...clientDetails },
    }));
  },
  setIsPartnerDrawerOpen: (partnerId?: string | null) => {
    return set((state) => ({
      isPartnerDrawerOpen:
        (partnerId !== null && partnerId !== undefined) || !state.isPartnerDrawerOpen,
      partnerId: partnerId || null,
      partnerDetails: partnerId ? state.partnerDetails : undefined,
    }));
  },
  setPartnerId: (partnerId: string | null) => {
    return set((state) => ({ ...state, partnerId }));
  },
  setPartnerDetails: (partnerDetails) => {
    return set((state) => ({
      ...state,
      partnerDetails: { ...state.partnerDetails, ...partnerDetails },
    }));
  },
  setFamilyAccountID: (familyAccountID: string | null) => {
    return set((state) => ({ ...state, familyAccountID }));
  },
  setIsFamilyAccountDrawerOpen: (familyAccountID?: string | null) => {
    return set((state) => ({
      isFamilyAccountDrawerOpen: !state.isFamilyAccountDrawerOpen,
      familyAccountID,
      partnerDetails: familyAccountID ? state.partnerDetails : undefined,
    }));
  },
  setFamilyAccountDetails: (familyAccountDetails) => {
    return set((state) => ({
      ...state,
      familyAccountDetails: {
        ...state.familyAccountDetails,
        ...familyAccountDetails,
      },
    }));
  },
  setIsReinvestModalOpen: (isReinvestModalOpen: boolean) => {
    return set({ isReinvestModalOpen });
  },
  setReinvestDeal: (reinvestDeal: any) => {
    return set({ reinvestDeal });
  },
  setRefetchClientData: (refetchFn?: () => void) => {
    return set({ refetchClientData: refetchFn });
  },
  setRefetchClientSummary: (refetchFn?: () => void) => {
    return set({ refetchClientSummary: refetchFn });
  },
  setRefetchPartnerData: (refetchFn?: () => void) => {
    return set({ refetchPartnerData: refetchFn });
  },
  setRefetchPartnerSummary: (refetchFn?: () => void) => {
    return set({ refetchPartnerSummary: refetchFn });
  },
}));
